import { render, staticRenderFns } from "./message-plugin.vue?vue&type=template&id=723ea7d0&scoped=true"
import script from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-plugin.vue?vue&type=style&index=0&id=723ea7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ea7d0",
  null
  
)

export default component.exports